// extracted by mini-css-extract-plugin
export default {"BodyLight":"body-light_BodyLight__CUWYW"};